import { render, staticRenderFns } from "./UndoReplacements.vue?vue&type=template&id=0046475a&"
import script from "./UndoReplacements.vue?vue&type=script&lang=js&"
export * from "./UndoReplacements.vue?vue&type=script&lang=js&"
import style0 from "./UndoReplacements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports